"use strict";
/*!
 *
 *  match.ts
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var step_vue_1 = __importDefault(require("match/step.vue"));
var question_vue_1 = __importDefault(require("match/question.vue"));
var result_vue_1 = __importDefault(require("match/result.vue"));
var navigation_vue_1 = __importDefault(require("match/navigation.vue"));
var axios_1 = __importDefault(require("axios"));
var default_1 = /** @class */ (function () {
    function default_1() {
        this.elem = '#Match';
        this.json = '/assets/js/products.json';
        if (document.querySelector(this.elem)) {
            this.getJSON();
        }
        ;
    }
    default_1.prototype.getJSON = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.get(this.json)];
                    case 1:
                        res = _a.sent();
                        this.products = res.data;
                        this.init();
                        return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.init = function () {
        this.app = new vue_1.default({
            el: this.elem,
            data: {
                state: 0,
                contents: 'question',
                a: ['', '', '', '', ''],
                answer: '',
                position: {
                    'transform': 'translate(0, 0)'
                },
                products: this.products,
                contentsHeight: 'auto'
            },
            watch: {
                state: {
                    handler: function () {
                        var _this = this;
                        this.position = {
                            'transform': "translate(-" + this.state * (100 / 6) + "%, 0)"
                        };
                        setTimeout(function () {
                            _this.setHeight();
                        }, 10);
                    }
                }
            },
            components: {
                step: step_vue_1.default,
                question: question_vue_1.default,
                result: result_vue_1.default,
                navigation: navigation_vue_1.default
            },
            mounted: function () {
                var self = this;
                this.setHeight();
                window.addEventListener('resize', function () {
                    self.setHeight();
                }, true);
                var dom = this.$refs.contents;
                dom.classList.add('-init');
            },
            methods: {
                setAnswer: function (val) {
                    this.a[this.state] = val;
                    this.answer = this.a.join('');
                },
                next: function () {
                    this.state++;
                },
                prev: function () {
                    this.state--;
                },
                reset: function () {
                    var _this = this;
                    var dom = this.$refs.contents;
                    dom.classList.remove('-init');
                    setTimeout(function () {
                        _this.state = 0;
                        _this.a = ['', '', '', '', '', ''];
                        setTimeout(function () {
                            dom.classList.add('-init');
                        }, 1000);
                    }, 700);
                    var top = $(dom).offset().top;
                    $(util.scroller).animate({
                        scrollTop: top - util.scrollGap
                    }, {
                        duration: 700,
                        easing: 'easeOutExpo',
                        queue: false
                    });
                },
                setHeight: function () {
                    var dom;
                    if (this.state === 0) {
                        dom = this.$refs.question0;
                    }
                    else if (this.state === 1) {
                        dom = this.$refs.question1;
                    }
                    else if (this.state === 2) {
                        dom = this.$refs.question2;
                    }
                    else if (this.state === 3) {
                        dom = this.$refs.question3;
                    }
                    else if (this.state === 4) {
                        dom = this.$refs.question4;
                    }
                    else if (this.state === 5) {
                        dom = this.$refs.result;
                    }
                    ;
                    this.contentsHeight = dom.$el.clientHeight + 1;
                }
            }
        });
    };
    return default_1;
}());
exports.default = default_1;
